import type { BookMap } from "../TradingOverlay";

export const ASK = "ask";
export const BID = "bid";
const NEW = "new";
const CHANGE = "change";
const BOOK_RESET = "book_reset";
// Alias text of book_reset: both mean the same reset entry.
const EMPTY_BOOK = "empty_book";
const BOOK_SNAPSHOT = "book_snapshot";

export const normalizePrice = (price: any): string => {
  return parseFloat(price?.toString() || "0").toString();
};

// Snapshot entries carry no action, so a book_snapshot replaces the ladder instead of
// amending it; an empty snapshot's lone empty_book entry is not a level.
export const applyBookMessage = (prev: BookMap, parsedEvent: any): BookMap => {
  const entries = parsedEvent.entries || [];
  if (parsedEvent.event_type === BOOK_SNAPSHOT) {
    const snapshot: BookMap = new Map();
    for (const item of entries) {
      if (item.type === ASK || item.type === BID) {
        snapshot.set(normalizePrice(item.price), item);
      }
    }
    return snapshot;
  }

  let book = prev;
  for (const item of entries) {
    if (item.type === ASK || item.type === BID) {
      if (book === prev) {
        book = new Map(prev);
      }
      if (item.action === NEW || item.action === CHANGE) {
        book.set(normalizePrice(item.price), item);
      } else {
        book.delete(normalizePrice(item.price));
      }
    } else if (item.type === BOOK_RESET || item.type === EMPTY_BOOK) {
      book = new Map();
    }
  }
  return book;
};
